import React, { useEffect, useState } from 'react';
import { Flex, Icon, IconButton, Text } from '@chakra-ui/react';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';

export const Pagination = ({ totalAmount, amountPerPage, currentPage, handleOnClick }) => {
  const [totalPages, setTotalPages] = useState(Math.ceil(totalAmount / amountPerPage));

  useEffect(() => {
    setTotalPages(Math.ceil(totalAmount / amountPerPage));
  }, [totalAmount, amountPerPage]);
  if (!totalPages || totalPages < 2) return null;

  return (
    <Flex pt="8">
      <Flex flexWrap="wrap" justifyContent="center">
        {currentPage === 1 ? null : (
          <IconButton onClick={() => handleOnClick(currentPage - 1)} aria-label="Previous Page" variant="ghost" icon={<CaretLeft />} />
        )}
        {totalPages &&
          new Array(totalPages).fill(0).map((_, index) => {
            return (
              <IconButton
                key={`PaginationPage${index}`}
                onClick={() => handleOnClick(index + 1)}
                aria-label="Next Page"
                variant="ghost"
                icon={<span>{index + 1}</span>}
                colorScheme={index + 1 === currentPage ? 'blue' : 'gray'}
              />
            );
          })}
        {currentPage === totalPages ? null : (
          <IconButton onClick={() => handleOnClick(currentPage + 1)} aria-label="Next Page" variant="ghost" icon={<CaretRight />} />
        )}
      </Flex>
    </Flex>
  );
};
